var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuxCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 676.99 384.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7bd3d;}.cls-19,.cls-2{fill:#181828;}.cls-10,.cls-13,.cls-3,.cls-42,.cls-5,.cls-6,.cls-64{fill:#fff;}.cls-3{opacity:0.48;}.cls-4{fill:#d39021;}.cls-6{opacity:0.61;}.cls-10,.cls-7{opacity:0.2;}.cls-8{fill:#113c47;}.cls-9{fill:#df8a3a;}.cls-10,.cls-41,.cls-42,.cls-43,.cls-46,.cls-56,.cls-57{isolation:isolate;}.cls-11{fill:#c0dbe2;}.cls-12{fill:#f7b14b;}.cls-13{opacity:0.7;}.cls-14{fill:#91dcdc;}.cls-15{fill:#5ba3ba;}.cls-16{fill:#d17e1c;}.cls-17{fill:#6f6372;}.cls-18{fill:#63456b;}.cls-19{opacity:0.5;}.cls-20{fill:#f04d6a;}.cls-21{fill:#928f93;}.cls-22{fill:#83c3db;}.cls-23{fill:#c0f3ff;}.cls-24,.cls-30,.cls-41,.cls-43{fill:#e89176;}.cls-25{fill:#ce7057;}.cls-26{fill:#ffbb59;}.cls-27{fill:#ffdbab;}.cls-28{fill:#f4a031;}.cls-29{fill:#fdc6a2;}.cls-30{opacity:0.62;}.cls-31{fill:#ffdbc7;}.cls-32{fill:#ffe8dc;}.cls-33{fill:#b4e4f9;}.cls-34{fill:#73c7e5;}.cls-35{fill:#eefbff;}.cls-36{opacity:0.15;}.cls-37{fill:#1b3c47;}.cls-38{fill:#e59328;}.cls-39{fill:#ffd097;}.cls-40{fill:#1b1b2b;}.cls-41{opacity:0.49;}.cls-42{opacity:0.55;}.cls-43{opacity:0.62;}.cls-44{fill:#ffc1b3;}.cls-45,.cls-64{opacity:0.25;}.cls-46{fill:#dff5f7;}.cls-46,.cls-56{opacity:0.8;}.cls-47{fill:#f1665d;}.cls-48{fill:#f7bd3b;}.cls-49{fill:#56c643;}.cls-50{fill:none;}.cls-51{fill:#8c7f93;}.cls-52{fill:#5ffd9f;}.cls-53{fill:#aeffcf;}.cls-54{fill:#7dc4ff;}.cls-55{fill:#12dd65;}.cls-56{fill:#b5e5e8;}.cls-57{fill:#c08976;opacity:0.39;}.cls-58{fill:#af143b;}.cls-59{fill:#91052d;}.cls-60{fill:#ffdede;}.cls-61{fill:#ea3d90;}.cls-62{fill:#c60c6e;}.cls-63{fill:#ff7dc7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 336") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.5,207.07h30.4a0,0,0,0,1,0,0v32.48a15.2,15.2,0,0,1-15.2,15.2h0a15.2,15.2,0,0,1-15.2-15.2V207.07A0,0,0,0,1,603.5,207.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M618.86,256.08a16.43,16.43,0,0,1-16.42-16.42V207.19a1.21,1.21,0,0,1,1.22-1.22h30.4a1.22,1.22,0,0,1,1.22,1.22v32.47A16.44,16.44,0,0,1,618.86,256.08Zm-14-47.68v31.26a14,14,0,0,0,14,14h0a14,14,0,0,0,14-14V208.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.23,168.9a61.1,61.1,0,0,0-12-21.92c11-4.5,23.31-3.22,32.37,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M601.05,157.52c-2.43-8.05-19.31-10.2-28.95-9.36,11-4.5,23.31-3.22,32.37,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M574.58,146.18c.44.51-1.37,1.19-.94,1.73,10.1-3.5,21.09-2.45,29.51,4.11l1.56-1.14C595.7,143.14,585.66,141.67,574.58,146.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M590.78,164.39,585,169a61.12,61.12,0,0,0-11.2-22.31h0A60.89,60.89,0,0,1,590.78,164.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.21,159a1,1,0,0,1-.8-.44c-4.91-8.05-11.82-9.68-11.93-9.68a.93.93,0,0,1-.71-1.07,1,1,0,0,1,1.08-.71c.31.07,7.79,1.84,13.11,10.54a.92.92,0,0,1-.3,1.27h0A1,1,0,0,1,586.21,159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M588.78,149.94a7.18,7.18,0,0,0-2.63-.62.3.3,0,0,1-.29-.31.31.31,0,0,1,.31-.29,8,8,0,0,1,2.86.65.31.31,0,0,1,.16.41.31.31,0,0,1-.41.16Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 581.68,
    cy: 148.43,
    rx: 1.08,
    ry: 1.35,
    transform: "translate(422.05 727.14) rotate(-88.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M584.67,170.12a1.21,1.21,0,0,1-1.16-.87,59.48,59.48,0,0,0-11.72-21.48,1.22,1.22,0,0,1-.25-1.07,1.2,1.2,0,0,1,.72-.84c11.92-4.87,24.49-3.09,33.63,4.76a1.21,1.21,0,0,1,.13,1.71,1.22,1.22,0,0,1-1.72.13c-8-6.89-19-8.69-29.56-4.94a61.72,61.72,0,0,1,11.1,21,1.21,1.21,0,0,1-.82,1.51A1,1,0,0,1,584.67,170.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M645.38,180.89a2.69,2.69,0,0,1-2.69-2.68V163a2.69,2.69,0,0,1,5.38,0v15.22a2.68,2.68,0,0,1-2.68,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M645.38,158.72a2.69,2.69,0,0,1-2.69-2.69v-5.69a2.69,2.69,0,0,1,5.38,0V156A2.68,2.68,0,0,1,645.38,158.72Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.18,160.47a60.69,60.69,0,0,1,11.94-21.92c-11-4.5-23.32-3.23-32.38,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M631.27,154.46c2.42-8.05,18.52-16.64,30.85-15.91-11-4.5-23.32-3.23-32.38,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M630.12,149.4c2.42-8.05,22.41-14.4,32.37-10.48-11-4.49-23.31-3.22-32.37,4.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M646.3,151.07l5.14,7.34c2.15-8.13,5.86-14,11.09-20.56l.1-1.75C655.85,140.78,650.66,144.09,646.3,151.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.4,142.72h6.12A35.47,35.47,0,0,1,657,178.19h0a35.47,35.47,0,0,1-35.48,35.48H615.4a35.47,35.47,0,0,1-35.48-35.48h0A35.47,35.47,0,0,1,615.4,142.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M615.4,142.72h6.12A35.47,35.47,0,0,1,657,178.19h0c-4.23-15.44-15.3-31.14-34.89-31.14H616c-19.59,0-29.82,13.42-36.06,31.14h0A35.47,35.47,0,0,1,615.4,142.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M657.57,177.76a35.47,35.47,0,0,1-35.47,35.47H616a35.47,35.47,0,0,1-35.47-35.47c0-.76,0-1.52.07-2.27a35.47,35.47,0,0,0,35.47,33.21h6.13a35.46,35.46,0,0,0,35.4-33.21C657.55,176.24,657.57,177,657.57,177.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.77,197.23c-7.41-1.75-6.87-.88-13.6-8.53,0,0-2,9.61,5.58,15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M646.41,202.39s-5.81-.82-11.32-6.66c0,0-1.25,7.92,4.41,12.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M666.3,186.94a1,1,0,0,1-.77-.42c-1.77-2.68-3.45-2.93-6.26-3.32a33.71,33.71,0,0,1-3.74-.69,33.62,33.62,0,0,0-5.37-.89,1,1,0,0,1-.84-1,.91.91,0,0,1,1-.84h0a35.1,35.1,0,0,1,5.67.93,30.78,30.78,0,0,0,3.55.66c2.85.41,5.31.75,7.52,4.12a.93.93,0,0,1-.26,1.3,1,1,0,0,1-.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M676.05,196.14a.93.93,0,0,1-.78-.42c-1.75-2.66-8.95-5.77-19.74-8.6a35,35,0,0,0-5.37-.88.94.94,0,0,1,.17-1.86,36.26,36.26,0,0,1,5.67.94c8.06,2.09,18.27,5.38,20.83,9.34a.92.92,0,0,1-.25,1.29h0A.89.89,0,0,1,676.05,196.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664.45,198.15h-.16a13.49,13.49,0,0,1-8-4.15,16,16,0,0,0-3.85-2.88,34.55,34.55,0,0,0-5.07-2,.92.92,0,0,1-.6-1.16v0a.94.94,0,0,1,1.16-.6,38.43,38.43,0,0,1,5.38,2.15,19.06,19.06,0,0,1,4.29,3.17c1.86,1.71,3.47,3.23,7,3.68a.94.94,0,0,1-.14,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M570.92,186.94a1,1,0,0,0,.78-.42c1.76-2.68,3.45-2.93,6.25-3.32a33.71,33.71,0,0,0,3.74-.69,33.8,33.8,0,0,1,5.37-.89,1,1,0,0,0,.84-1,.91.91,0,0,0-1-.84h0a35.1,35.1,0,0,0-5.67.93,30.78,30.78,0,0,1-3.55.66c-2.85.41-5.31.75-7.52,4.12a.93.93,0,0,0,.26,1.3,1,1,0,0,0,.51.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M561.17,196.14a.93.93,0,0,0,.78-.42c1.75-2.66,8.95-5.77,19.74-8.6a35,35,0,0,1,5.37-.88.94.94,0,0,0-.17-1.86,36.26,36.26,0,0,0-5.67.94c-8.06,2.09-18.27,5.38-20.83,9.34a.92.92,0,0,0,.25,1.29h0A.89.89,0,0,0,561.17,196.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M572.77,198.15h.16a13.49,13.49,0,0,0,8-4.15,16.2,16.2,0,0,1,3.86-2.88,34,34,0,0,1,5.06-2,.92.92,0,0,0,.6-1.16v0a.94.94,0,0,0-1.16-.6,38.43,38.43,0,0,0-5.38,2.15,19.06,19.06,0,0,0-4.29,3.17c-1.86,1.71-3.46,3.23-7,3.68a.94.94,0,0,0,.14,1.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 591.72,
    y: 158.31,
    width: 23.8,
    height: 28.97,
    rx: 11.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 603.35,
    cy: 173.72,
    r: 8.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 605.84,
    cy: 177.47,
    r: 2.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 601.53,
    cy: 170.34,
    rx: 4.45,
    ry: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 622.82,
    y: 158.31,
    width: 23.8,
    height: 28.97,
    rx: 11.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 634.45,
    cy: 173.72,
    r: 8.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 636.94,
    cy: 177.47,
    r: 2.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 632.62,
    cy: 170.34,
    rx: 4.45,
    ry: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M602.74,152.19a26.51,26.51,0,0,1,5.66-1.95,29.63,29.63,0,0,1,5.93-.69.64.64,0,0,1,.64.62.63.63,0,0,1-.59.63,29.54,29.54,0,0,0-5.61,1,32.59,32.59,0,0,0-5.33,1.92.83.83,0,0,1-1.09-.42A.82.82,0,0,1,602.74,152.19Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 618.54,
    cy: 150.08,
    rx: 1.08,
    ry: 1.35,
    transform: "translate(456.54 765.61) rotate(-88.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M621.52,214.89H615.4a36.7,36.7,0,1,1,0-73.39h6.12a36.7,36.7,0,1,1,0,73.39Zm-6.12-71a34.26,34.26,0,0,0,0,68.52h6.12a34.26,34.26,0,0,0,0-68.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.35,160.22a1.33,1.33,0,0,1-.28,0,1.21,1.21,0,0,1-.91-1.46,57.79,57.79,0,0,1,8.94-20.92c-10.81-3.06-21.62-.57-29.18,6.83a1.22,1.22,0,1,1-1.71-1.74c8.61-8.41,21-11,33.26-6.91a1.24,1.24,0,0,1,.59,1.89c-4.57,6.11-7.51,12.71-9.53,21.4A1.22,1.22,0,0,1,652.35,160.22Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 624.94,
    cy: 205.15,
    rx: 2.59,
    ry: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 620.04,
    cy: 205.36,
    r: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 644.21,
    cy: 145.01,
    rx: 1.82,
    ry: 0.89,
    transform: "translate(13.8 341.53) rotate(-30)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 646.3,
    cy: 146.64,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M617.76,185.47a1.74,1.74,0,0,0-1.32,2.89c.79.87,1.93,1.91,3.2,1.91s2.41-1,3.19-1.91a1.74,1.74,0,0,0-.16-2.46,1.8,1.8,0,0,0-1.1-.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 376.08,
    y: 323.79,
    width: 23.87,
    height: 2.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "402.27 298.71 402.06 301.15 372.83 301.15 372.62 298.71 402.27 298.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.56,346.71H378.87a3.2,3.2,0,0,1-3.17-2.92l-3.81-46.08a1,1,0,0,1,1-1.09h29.65a1,1,0,0,1,.74.32,1,1,0,0,1,.27.77L401,328.07a1,1,0,1,1-2-.16l2.42-29.28H374l3.73,45a1.17,1.17,0,0,0,1.16,1.07h17.69a1.17,1.17,0,0,0,1.16-1.07l.93-11.2a1,1,0,0,1,1.09-.92,1,1,0,0,1,.92,1.09l-.93,11.19A3.2,3.2,0,0,1,396.56,346.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 368.19,
    y: 293.28,
    width: 39.06,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.89,299.16H370.54a3.32,3.32,0,1,1,0-6.64h34.35a3.32,3.32,0,0,1,0,6.64Zm-34.35-4.7a1.38,1.38,0,1,0,0,2.76h34.35a1.38,1.38,0,1,0,0-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.8,294.18h0a.72.72,0,0,1-.68-.76c0-.22.36-5.38,4.8-7.07a.73.73,0,0,1,1,.68v6a.72.72,0,0,1-1.44,0v-4.84c-2.67,1.7-2.9,5.28-2.91,5.32A.71.71,0,0,1,373.8,294.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 392.19,
    cy: 305.08,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 394.3,
    cy: 301.76,
    r: 1.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 397.38,
    cy: 304.44,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 398.57,
    cy: 301.89,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 391.41,
    cy: 301.11,
    r: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 394.6,
    cy: 307.28,
    r: 0.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "370.95 305.89 372.22 322.52 403.63 322.52 405.08 305.89 370.95 305.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.45,324.07H372a1,1,0,0,1-1-.93l-1.26-16.63a1,1,0,0,1,1-1.08h34.12a1,1,0,0,1,.75.32,1,1,0,0,1,.26.77l-1.45,16.63A1,1,0,0,1,403.45,324.07Zm-30.48-2h29.56l1.27-14.62H371.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.05,311.24h-9a.47.47,0,0,1,0-.93h9a.47.47,0,1,1,0,.93Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 378.25,
    cy: 316.8,
    rx: 3.68,
    ry: 2.89,
    transform: "translate(-113.22 360.25) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 384.01,
    cy: 314.43,
    rx: 1.44,
    ry: 1.14,
    transform: "translate(-109.86 363.63) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 210.13,
    y: 327.96,
    width: 112.38,
    height: 17.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 210.13,
    y: 327.96,
    width: 112.38,
    height: 4.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.52,346.88H210.13a1.45,1.45,0,0,1-1.45-1.46V328a1.45,1.45,0,0,1,1.45-1.45H322.52A1.45,1.45,0,0,1,324,328v17.46A1.45,1.45,0,0,1,322.52,346.88ZM211.59,344H321.06V329.42H211.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M115.69,353.62h516.7a0,0,0,0,1,0,0v0a30.24,30.24,0,0,1-30.24,30.24H145.94a30.24,30.24,0,0,1-30.24-30.24v0a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M631.59,360.3a28.37,28.37,0,0,1-1.23,4H117.73a28.37,28.37,0,0,1-1.23-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M602.15,384H145.94a31.44,31.44,0,0,1-31.4-31.4,1.16,1.16,0,0,1,2.31,0,29.12,29.12,0,0,0,29.09,29.09H602.15a29.12,29.12,0,0,0,29.09-29.09,1.15,1.15,0,1,1,2.3,0A31.43,31.43,0,0,1,602.15,384Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 568.49,
    y: 220.97,
    width: 95.09,
    height: 124.14,
    rx: 16.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M595.82,344.38H584.68a16.19,16.19,0,0,1-16.19-16.19V236.45a16.19,16.19,0,0,1,16.19-16.2h11.14a16.2,16.2,0,0,0-16.2,16.2v91.74A16.19,16.19,0,0,0,595.82,344.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 616.03,
    cy: 254.16,
    r: 10.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 616.03,
    cy: 254.16,
    r: 7.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616,265.54a11.38,11.38,0,1,1,11.38-11.38A11.4,11.4,0,0,1,616,265.54Zm0-20.33a8.95,8.95,0,1,0,9,8.95A9,9,0,0,0,616,245.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 616.03,
    cy: 297.71,
    r: 22.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 616.03,
    cy: 297.71,
    r: 15.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616,321.4a23.69,23.69,0,1,1,23.69-23.69A23.72,23.72,0,0,1,616,321.4Zm0-44.28a20.59,20.59,0,1,0,20.59,20.59A20.61,20.61,0,0,0,616,277.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M590.23,236.47a3.73,3.73,0,1,1,3.72-3.72A3.73,3.73,0,0,1,590.23,236.47Zm0-5.59a1.87,1.87,0,1,0,1.86,1.87A1.87,1.87,0,0,0,590.23,230.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.84,236.47a3.73,3.73,0,1,1,3.72-3.72A3.73,3.73,0,0,1,641.84,236.47Zm0-5.59a1.87,1.87,0,1,0,1.86,1.87A1.87,1.87,0,0,0,641.84,230.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 616.03,
    cy: 229.95,
    r: 3.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616,234.42a4.47,4.47,0,1,1,4.48-4.47A4.47,4.47,0,0,1,616,234.42Zm0-7.08a2.61,2.61,0,1,0,2.61,2.61A2.61,2.61,0,0,0,616,227.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M590.23,337.61a3.72,3.72,0,1,1,3.72-3.72A3.73,3.73,0,0,1,590.23,337.61Zm0-5.58a1.86,1.86,0,1,0,1.86,1.86A1.86,1.86,0,0,0,590.23,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.84,337.61a3.72,3.72,0,1,1,3.72-3.72A3.73,3.73,0,0,1,641.84,337.61Zm0-5.58a1.86,1.86,0,1,0,1.86,1.86A1.86,1.86,0,0,0,641.84,332Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 577.8,
    y: 271.47,
    width: 4.36,
    height: 19.09,
    rx: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 657.91,
    y: 248.02,
    width: 4.36,
    height: 19.09,
    rx: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 657.91,
    y: 308.2,
    width: 4.36,
    height: 19.09,
    rx: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.38,346.66H584.69a17.77,17.77,0,0,1-17.75-17.75V237.17a17.77,17.77,0,0,1,17.75-17.75h62.69a17.77,17.77,0,0,1,17.75,17.75v91.74A17.77,17.77,0,0,1,647.38,346.66ZM584.69,222.53A14.66,14.66,0,0,0,570,237.17v91.74a14.66,14.66,0,0,0,14.65,14.65h62.69A14.66,14.66,0,0,0,662,328.91V237.17a14.66,14.66,0,0,0-14.64-14.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 93.02,
    y: 220.97,
    width: 95.09,
    height: 124.14,
    rx: 16.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M120.35,344.38H109.22A16.19,16.19,0,0,1,93,328.19V236.45a16.2,16.2,0,0,1,16.2-16.2h11.13a16.2,16.2,0,0,0-16.2,16.2v91.74A16.19,16.19,0,0,0,120.35,344.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 140.57,
    cy: 254.16,
    r: 10.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 140.57,
    cy: 254.16,
    r: 7.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.57,265.54A11.38,11.38,0,1,1,152,254.16,11.39,11.39,0,0,1,140.57,265.54Zm0-20.33a8.95,8.95,0,1,0,8.94,8.95A9,9,0,0,0,140.57,245.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 140.57,
    cy: 297.71,
    r: 22.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 140.57,
    cy: 297.71,
    r: 15.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.57,321.4a23.69,23.69,0,1,1,23.69-23.69A23.72,23.72,0,0,1,140.57,321.4Zm0-44.28a20.59,20.59,0,1,0,20.58,20.59A20.61,20.61,0,0,0,140.57,277.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.76,236.47a3.73,3.73,0,1,1,3.72-3.72A3.73,3.73,0,0,1,114.76,236.47Zm0-5.59a1.87,1.87,0,1,0,1.86,1.87A1.87,1.87,0,0,0,114.76,230.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.37,236.47a3.73,3.73,0,1,1,3.73-3.72A3.73,3.73,0,0,1,166.37,236.47Zm0-5.59a1.87,1.87,0,1,0,1.86,1.87A1.87,1.87,0,0,0,166.37,230.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.76,337.61a3.72,3.72,0,1,1,3.72-3.72A3.73,3.73,0,0,1,114.76,337.61Zm0-5.58a1.86,1.86,0,1,0,1.86,1.86A1.86,1.86,0,0,0,114.76,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.37,337.61a3.72,3.72,0,1,1,3.73-3.72A3.73,3.73,0,0,1,166.37,337.61Zm0-5.58a1.86,1.86,0,1,0,1.86,1.86A1.86,1.86,0,0,0,166.37,332Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 102.33,
    y: 271.47,
    width: 4.36,
    height: 19.09,
    rx: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 182.44,
    y: 248.02,
    width: 4.36,
    height: 19.09,
    rx: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 182.44,
    y: 308.2,
    width: 4.36,
    height: 19.09,
    rx: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.91,346.66H109.22a17.77,17.77,0,0,1-17.75-17.75V237.17a17.77,17.77,0,0,1,17.75-17.75h62.69a17.77,17.77,0,0,1,17.75,17.75v91.74A17.77,17.77,0,0,1,171.91,346.66ZM109.22,222.53a14.66,14.66,0,0,0-14.64,14.64v91.74a14.66,14.66,0,0,0,14.64,14.65h62.69a14.66,14.66,0,0,0,14.65-14.65V237.17a14.66,14.66,0,0,0-14.65-14.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M331.21,343.91a18,18,0,1,1,35.92,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M352.41,326.07a18,18,0,0,0-15.82,17.84H332.3a18,18,0,0,1,18-18A16.89,16.89,0,0,1,352.41,326.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.13,345.15a1.24,1.24,0,0,1-1.23-1.24,16.63,16.63,0,0,0-2.71-9.12,1.24,1.24,0,0,1,2.08-1.36,19.16,19.16,0,0,1,3.1,10.48A1.24,1.24,0,0,1,367.13,345.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.21,345.15a1.24,1.24,0,0,1-1.24-1.24,19.2,19.2,0,0,1,31.21-15,1.24,1.24,0,1,1-1.55,1.93,16.57,16.57,0,0,0-10.46-3.67,16.75,16.75,0,0,0-16.73,16.73A1.24,1.24,0,0,1,331.21,345.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M488.94,54.37a25.94,25.94,0,0,1-51.87,0c0-14.33,11.61-27.18,25.93-27.18S488.94,40,488.94,54.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M487.66,55.17a25.69,25.69,0,0,1-.75,5.57h-1.16a51.46,51.46,0,0,1-36.52-15.13,52.23,52.23,0,0,1-6.82-8.42,25.09,25.09,0,0,1,2.32-2.29,51.1,51.1,0,0,0,4.5,5.14,51.46,51.46,0,0,0,36.52,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M463,81.67a27.29,27.29,0,0,1-24-14.35,1.36,1.36,0,1,1,2.4-1.29,24.58,24.58,0,0,0,46.21-11.66c0-14-11.26-25.82-24.58-25.82s-24.57,11.82-24.57,25.82a24.8,24.8,0,0,0,.83,6.37,1.36,1.36,0,1,1-2.63.7,27.06,27.06,0,0,1-.93-7.07c0-15.48,12.5-28.55,27.3-28.55s27.31,13.07,27.31,28.55A27.34,27.34,0,0,1,463,81.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M521.88,72.42a25.94,25.94,0,0,0,51.88,0c0-14.33-11.61-27.18-25.94-27.18S521.88,58.09,521.88,72.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M523.16,73.22a25.69,25.69,0,0,0,.76,5.57h1.16a51.7,51.7,0,0,0,43.33-23.55A26.28,26.28,0,0,0,566.1,53c-1.39,1.81-4.91.48-6.52,2.09-9.34,9.35-20.24,18.18-34.5,18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547.82,99.72a27.34,27.34,0,0,1-27.3-27.3c0-15.48,12.5-28.55,27.3-28.55s27.3,13.07,27.3,28.55a27.62,27.62,0,0,1-.92,7.08,1.37,1.37,0,0,1-2.64-.71,24.38,24.38,0,0,0,.84-6.37c0-14-11.26-25.82-24.58-25.82s-24.57,11.82-24.57,25.82a24.58,24.58,0,0,0,46.21,11.66,1.36,1.36,0,1,1,2.4,1.29A27.3,27.3,0,0,1,547.82,99.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M450.17,338.66l-52.1,11.16v-95a26.05,26.05,0,0,1,26.05-26.06h0a26.05,26.05,0,0,1,26.05,26.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M426.66,228.91a26,26,0,0,0-23,25.87v93.73l-6.15,1.31v-95a26.05,26.05,0,0,1,26.06-26.05A23.88,23.88,0,0,1,426.66,228.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.07,351a1.21,1.21,0,0,1-.77-.27,1.24,1.24,0,0,1-.45-.95v-95a27.27,27.27,0,1,1,54.54,0v83.88a1.22,1.22,0,0,1-1,1.19L398.32,351A1.07,1.07,0,0,1,398.07,351Zm26.05-121.1a24.86,24.86,0,0,0-24.83,24.84v93.54L449,337.68v-82.9A24.86,24.86,0,0,0,424.12,229.94Zm26.05,108.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M512.58,199h0a42.11,42.11,0,0,1,42.11,42.11V352.61a0,0,0,0,1,0,0H412.1a0,0,0,0,1,0,0V299.48A100.48,100.48,0,0,1,512.58,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M554.55,241.9h0a0,0,0,0,1,0,0V348.38a0,0,0,0,1,0,0H544a0,0,0,0,1,0,0v-96A10.53,10.53,0,0,1,554.55,241.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M517.36,199.22a100.51,100.51,0,0,0-93.67,100.26v53.13h-11.2V299.48A100.49,100.49,0,0,1,513,199,42.29,42.29,0,0,1,517.36,199.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.69,353.83H412.1a1.21,1.21,0,0,1-1.22-1.22V299.48a101.81,101.81,0,0,1,101.7-101.7,43.37,43.37,0,0,1,43.33,43.32V352.61A1.22,1.22,0,0,1,554.69,353.83Zm-141.37-2.44H553.47V241.1a40.94,40.94,0,0,0-40.89-40.89,99.38,99.38,0,0,0-99.26,99.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 531.05,
    y: 226.8,
    width: 41.81,
    height: 115.09,
    rx: 20.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M555.56,341.78c-.72.07-1.44.11-2.18.11A20.91,20.91,0,0,1,532.48,321V247.7a20.9,20.9,0,0,1,20.9-20.9c.74,0,1.46,0,2.18.11a20.91,20.91,0,0,0-18.73,20.79V321A20.92,20.92,0,0,0,555.56,341.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552,343.11A22.15,22.15,0,0,1,529.84,321V247.7a22.12,22.12,0,0,1,44.24,0V321A22.15,22.15,0,0,1,552,343.11ZM552,228a19.71,19.71,0,0,0-19.69,19.68V321a19.69,19.69,0,1,0,39.38,0V247.7A19.71,19.71,0,0,0,552,228Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 502.84,
    y: 271.92,
    width: 35.41,
    height: 115.09,
    rx: 17.71,
    transform: "translate(850.01 -191.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M560.38,348.39H480.71a18.93,18.93,0,0,1,0-37.85h79.67a18.93,18.93,0,1,1,0,37.85ZM480.71,313a16.49,16.49,0,1,0,0,33h79.67a16.49,16.49,0,1,0,0-33Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 457.99,
    cy: 329.89,
    rx: 22.56,
    ry: 17.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M460.53,347a1.53,1.53,0,0,1-.23-3h0a27.23,27.23,0,0,0,7.8-2.68c4.95-2.66,7.59-6.4,7.84-11.11a1.51,1.51,0,0,1,1.61-1.45,1.54,1.54,0,0,1,1.45,1.61c-.31,5.8-3.6,10.54-9.53,13.69a30.37,30.37,0,0,1-8.72,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M458,348.63c-6.56,0-13.09-2.12-17.75-6.26-4.15-3.7-6.27-8.47-5.95-13.42.32-5.17,3.22-9.87,8.15-13.25a1.15,1.15,0,1,1,1.3,1.9c-4.33,3-6.88,7-7.16,11.49-.27,4.24,1.58,8.34,5.19,11.56,7.84,7,21.49,7.66,30.43,1.53,4.33-3,6.87-7.05,7.16-11.49.26-4.24-1.58-8.34-5.2-11.56a1.15,1.15,0,0,1,1.53-1.72c4.16,3.7,6.27,8.47,6,13.42-.33,5.17-3.22,9.87-8.15,13.25A27.61,27.61,0,0,1,458,348.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 454.12,
    cy: 325.7,
    rx: 10.47,
    ry: 6.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 426.41,
    y: 310.9,
    width: 3.64,
    height: 19.62,
    rx: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 540.6,
    y: 253.08,
    width: 3.64,
    height: 19.62,
    rx: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 407.4,
    y: 251.12,
    width: 3.64,
    height: 19.62,
    rx: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 148.16,
    y: 298.4,
    width: 58.16,
    height: 54.73,
    transform: "translate(354.48 651.53) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.32,354.37H148.16a1.25,1.25,0,0,1-1.24-1.24V298.4a1.24,1.24,0,0,1,1.24-1.24h58.16a1.24,1.24,0,0,1,1.24,1.24v54.73A1.25,1.25,0,0,1,206.32,354.37Zm-56.92-2.48h55.68V299.64H149.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 160.05,
    y: 298.4,
    width: 58.16,
    height: 54.73,
    transform: "translate(378.26 651.53) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.21,354.37H160.05a1.24,1.24,0,0,1-1.24-1.24V298.4a1.23,1.23,0,0,1,1.24-1.24h58.16a1.24,1.24,0,0,1,1.24,1.24v54.73A1.25,1.25,0,0,1,218.21,354.37Zm-56.92-2.48H217V299.64H161.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M165.79,316.48H203a0,0,0,0,1,0,0v8.68a0,0,0,0,1,0,0H165.79a4.34,4.34,0,0,1-4.34-4.34v0A4.34,4.34,0,0,1,165.79,316.48Z",
    transform: "translate(364.4 641.64) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 47.73,
    y: 129.98,
    width: 259.84,
    height: 185.06,
    rx: 11.92,
    transform: "translate(355.3 445.02) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.65,316.28h-236a13.18,13.18,0,0,1-13.16-13.16V141.9a13.18,13.18,0,0,1,13.16-13.16h117a1.24,1.24,0,1,1,0,2.48h-117A10.69,10.69,0,0,0,49,141.9V303.12A10.69,10.69,0,0,0,59.65,313.8h236a10.69,10.69,0,0,0,10.68-10.68V141.9a10.69,10.69,0,0,0-10.68-10.68H251.48a1.24,1.24,0,1,1,0-2.48h44.17a13.18,13.18,0,0,1,13.16,13.16V303.12A13.18,13.18,0,0,1,295.65,316.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 59.02,
    y: 129.98,
    width: 259.84,
    height: 185.06,
    rx: 11.92,
    transform: "translate(377.88 445.02) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 70.43,
    y: 139.79,
    width: 240.91,
    height: 167.83,
    rx: 7.94,
    transform: "translate(381.77 447.41) rotate(-180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 188.68,
    cy: 325.28,
    rx: 1.54,
    ry: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 185.3,
    cy: 327.96,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 191.39,
    cy: 327.51,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 172.02,
    cy: 324.46,
    r: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 194.17,
    cy: 324.46,
    r: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 177.29,
    cy: 327.53,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 172.11,
    cy: 329.98,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 167.73,
    cy: 327.96,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 169.45,
    cy: 327.53,
    r: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 303.75,
    y: 200.35,
    width: 6.76,
    height: 94.24,
    rx: 3.38,
    transform: "translate(614.25 494.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 303.75,
    y: 154.37,
    width: 6.76,
    height: 29.8,
    rx: 3.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 71.77,
    y: 192.66,
    width: 6.76,
    height: 44.67,
    rx: 3.38,
    transform: "translate(150.3 429.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 71.77,
    y: 147.07,
    width: 6.76,
    height: 29.8,
    rx: 3.38,
    transform: "translate(150.3 323.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 71.77,
    y: 259.42,
    width: 6.76,
    height: 13.27,
    rx: 3.38,
    transform: "translate(150.3 532.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.43,170.51a1.25,1.25,0,0,1-1.24-1.24V147.73a9.19,9.19,0,0,1,9.18-9.18H245.21a1.24,1.24,0,1,1,0,2.48H78.37a6.71,6.71,0,0,0-6.7,6.7v21.54A1.25,1.25,0,0,1,70.43,170.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.4,308.86H125.51a1.24,1.24,0,1,1,0-2.48H303.4a6.71,6.71,0,0,0,6.7-6.7v-152a6.71,6.71,0,0,0-6.7-6.7H256.07a1.24,1.24,0,1,1,0-2.48H303.4a9.19,9.19,0,0,1,9.18,9.18v152A9.19,9.19,0,0,1,303.4,308.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.61,308.86H78.37a9.19,9.19,0,0,1-9.18-9.18v-48a1.24,1.24,0,0,1,2.48,0v48a6.71,6.71,0,0,0,6.7,6.7h37.24a1.24,1.24,0,0,1,0,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.43,242.72a1.25,1.25,0,0,1-1.24-1.24V179.22a1.24,1.24,0,1,1,2.48,0v62.26A1.25,1.25,0,0,1,70.43,242.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 56.94,
    y: 149.8,
    width: 10.21,
    height: 5.59,
    rx: 2.79,
    transform: "translate(214.64 90.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 54.88,
    y: 252.11,
    width: 14.34,
    height: 5.59,
    rx: 2.79,
    transform: "translate(316.95 192.86) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 56.94,
    y: 186.47,
    width: 10.21,
    height: 5.59,
    rx: 2.79,
    transform: "translate(251.31 127.22) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.94,316.28h-236a13.18,13.18,0,0,1-13.16-13.16V141.9a13.18,13.18,0,0,1,13.16-13.16H225.66a1.24,1.24,0,1,1,0,2.48H70.94A10.69,10.69,0,0,0,60.26,141.9V303.12A10.69,10.69,0,0,0,70.94,313.8h236a10.69,10.69,0,0,0,10.68-10.68V141.9a10.69,10.69,0,0,0-10.68-10.68H235.07a1.24,1.24,0,1,1,0-2.48h71.87A13.18,13.18,0,0,1,320.1,141.9V303.12A13.18,13.18,0,0,1,306.94,316.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M392.13,192.34H379V170.15h39.07a1.58,1.58,0,1,1,0,3.16H382.17v15.87h10a1.58,1.58,0,1,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M402.47,192.34h-5.69a1.58,1.58,0,1,1,0-3.16h5.69a1.58,1.58,0,1,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M406.86,192.34h-.12a1.58,1.58,0,1,1,0-3.16h.12a1.58,1.58,0,0,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M434.51,192.34H411.28a1.58,1.58,0,0,1,0-3.16h20.08V173.31h-7a1.58,1.58,0,1,1,0-3.16h10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M407.91,173.31H352.42V151.17h55.49Zm-52.35-3.16h49.19V154.32H355.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M110.6,112H97.45V89.83h39.08a1.58,1.58,0,0,1,0,3.15H100.64v15.88h10a1.58,1.58,0,1,1,0,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M121,112h-5.7a1.58,1.58,0,0,1,0-3.15H121a1.58,1.58,0,0,1,0,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M125.33,112h-.11a1.58,1.58,0,1,1,0-3.15h.11a1.58,1.58,0,1,1,0,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M153,112H129.76a1.58,1.58,0,1,1,0-3.15h20.07V93h-7a1.58,1.58,0,1,1,0-3.15H153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M126.38,93H70.89V70.84h55.49ZM74,89.83h49.19V74H74.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M625.65,103.13H612.5V80.94h39.07a1.58,1.58,0,0,1,0,3.16H615.69V100h10a1.58,1.58,0,1,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M636,103.13H630.3a1.58,1.58,0,1,1,0-3.16H636a1.58,1.58,0,1,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M640.38,103.13h-.12a1.58,1.58,0,0,1,0-3.16h.12a1.58,1.58,0,0,1,0,3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M668,103.13H644.8a1.58,1.58,0,0,1,0-3.16h20.08V84.1h-7a1.58,1.58,0,1,1,0-3.16h10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M641.43,84.1H585.94V62h55.49Zm-52.35-3.16h49.19V65.11H589.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.59,345.9H283.86a.93.93,0,1,1,0-1.86h11.73a.93.93,0,0,1,0,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.59,350.71H283.86a.94.94,0,1,1,0-1.87h11.73a.94.94,0,0,1,0,1.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 262.75,
    cy: 354.03,
    rx: 1.4,
    ry: 2.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 262.34,
    cy: 359.31,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 298.2,
    cy: 358.11,
    r: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 96.1,
    y: 344.59,
    width: 553.37,
    height: 14.95,
    rx: 7.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 96.1,
    y: 344.59,
    width: 553.37,
    height: 14.95,
    rx: 7.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M649.46,351.72A7.48,7.48,0,0,1,642,359.2H103.57a7.48,7.48,0,0,1-7.48-7.48,7.27,7.27,0,0,1,.61-2.92,7.46,7.46,0,0,0,6.87,4.54H642a7.49,7.49,0,0,0,5.28-2.18,7.33,7.33,0,0,0,1.59-2.36A7.26,7.26,0,0,1,649.46,351.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547.49,345.48h-20a1.15,1.15,0,1,1,0-2.3h20a1.15,1.15,0,1,1,0,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.9,350.63H96.74a.89.89,0,0,1,0-1.77H117.9a.89.89,0,1,1,0,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.91,350.63h-3.49a.89.89,0,0,1,0-1.77h3.49a.89.89,0,0,1,0,1.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 276.5,
    y: 345.23,
    width: 61.99,
    height: 4.29,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 233.27,
    y: 345.23,
    width: 34.64,
    height: 4.29,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 160.62,
    y: 345.23,
    width: 34.64,
    height: 4.29,
    rx: 2.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642,360.43H103.57a8.63,8.63,0,0,1,0-17.25H515.86a1.15,1.15,0,1,1,0,2.3H103.57a6.33,6.33,0,0,0,0,12.65H642a6.33,6.33,0,0,0,0-12.65H560.24a1.15,1.15,0,1,1,0-2.3H642a8.63,8.63,0,1,1,0,17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M446.88,100.57l6.66.13a15.76,15.76,0,0,1,15.4,16h0A15.68,15.68,0,0,1,453,132.15h0l-6.66-.13a15.76,15.76,0,0,1-15.42-16h0a15.68,15.68,0,0,1,15.95-15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.4,117.12h0a1.36,1.36,0,0,1-1.35-1.38,16.8,16.8,0,0,1,3.32-9.82,1.36,1.36,0,1,1,2.19,1.62,14.06,14.06,0,0,0-2.78,8.24A1.36,1.36,0,0,1,430.4,117.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.75,133.31h-.3l-6.68-.13a17.08,17.08,0,0,1-15.65-11,1.37,1.37,0,0,1,.79-1.76,1.36,1.36,0,0,1,1.76.79,14.33,14.33,0,0,0,13.16,9.27l6.64.14a14.38,14.38,0,0,0,.55-28.75l-6.65-.14a14.28,14.28,0,0,0-7.47,1.91,1.36,1.36,0,0,1-1.86-.49,1.37,1.37,0,0,1,.49-1.87,17,17,0,0,1,8.9-2.27l6.65.13a17.11,17.11,0,0,1-.33,34.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M449.18,113.44l3.46.06a8.19,8.19,0,0,1,8,8.34h0a8.18,8.18,0,0,1-8.32,8l-3.46-.07a8.19,8.19,0,0,1-8-8.33h0A8.17,8.17,0,0,1,449.18,113.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M437.52,110.88a5.8,5.8,0,0,1,2.91-3.17c1.16-.45.69-2.34-.51-1.88a7.7,7.7,0,0,0-4.1,4.09c-.48,1.14,1.19,2.13,1.68,1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 435.31,
    cy: 114.5,
    rx: 1.55,
    ry: 1.24,
    transform: "matrix(0.15, -0.99, 0.99, 0.15, 258.45, 528.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M557,100.57l6.66.13a15.76,15.76,0,0,1,15.42,16h0a15.68,15.68,0,0,1-15.95,15.41h0l-6.65-.13A15.76,15.76,0,0,1,541,116h0a15.68,15.68,0,0,1,16-15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.36,133.33h-.29l-6.69-.14a17.16,17.16,0,0,1-16.76-17.43,17.05,17.05,0,0,1,17-16.75H557l6.65.13a17.09,17.09,0,0,1-.28,34.18Zm-6.69-31.59a14.32,14.32,0,0,0-14.32,14.07,14.43,14.43,0,0,0,14.09,14.66l6.65.13a14.36,14.36,0,0,0,.5-28.72l-6.65-.14h-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M559.79,113.44l3.47.06a8.2,8.2,0,0,1,8,8.33v0h0a8.19,8.19,0,0,1-8.33,8l-3.45-.07a8.19,8.19,0,0,1-8-8.33h0A8.18,8.18,0,0,1,559.79,113.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M440.47,118.54a1,1,0,0,1-.79-1.67,13.55,13.55,0,0,1,7.79-4.71,1,1,0,0,1,.41,2,11.43,11.43,0,0,0-6.61,4A1,1,0,0,1,440.47,118.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M572.07,118.54a1,1,0,0,1-.8-.38,11.46,11.46,0,0,0-6.61-4,1,1,0,0,1,.41-2,13.55,13.55,0,0,1,7.79,4.71,1,1,0,0,1-.15,1.44A1,1,0,0,1,572.07,118.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M545.17,34.62c.69.59,1.29,1.21,1.91,1.83a58.21,58.21,0,0,1,17.11,41.29V130a58.4,58.4,0,1,1-116.8,1.27c0-.42,0-.84,0-1.27V77.74a58.25,58.25,0,0,1,19-43.13C487.62,15.24,523.88,15.37,545.17,34.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M547.4,36.72c-.62-.62-1.26-1.23-1.91-1.82a57.94,57.94,0,0,1-6,3.18c.28.28.53.58.79.88l2.11,2.47A62,62,0,0,1,550.29,54h-70a6.29,6.29,0,0,0,6.29,6.28h66.17a52.7,52.7,0,0,1,2.48,16.29V130.3a58.4,58.4,0,0,1-53.77,58.22c1.52.12,3.07.18,4.62.18a58.39,58.39,0,0,0,58.4-58.4V78A58.21,58.21,0,0,0,547.4,36.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M518.28,199.55c0,2.51.71,5.34-.47,7.3-2.34,3.91-8.07,5.9-13.06,5.81h0a13.65,13.65,0,0,1-13.35-13.85l.68-10.89v-.68l27,.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M520,188.4l-1.7,14.13a15.92,15.92,0,0,1-9.25-.74,75.12,75.12,0,0,0-16.28-5.19h-.13l.14-8.18a77.57,77.57,0,0,0,27.22,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 482.74,
    cy: 182.33,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 492.76,
    cy: 185.81,
    r: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M511,187.58c-1.49.11-3,.17-4.53.17-32.25,0-61.86-25.73-58.4-58.4V77.06a58.24,58.24,0,0,1,19-43.12c1.85,1.12,1.45,2.17,3.53,3.13-9.83,10.44-17.44,24.54-17.44,40v52.29C453.22,160.09,476.9,186.57,511,187.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 538.87,
    cy: 96.14,
    r: 4.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.37,154.8a1.37,1.37,0,0,1-1.23-.78,21.42,21.42,0,0,1-1.46-4,1.37,1.37,0,1,1,2.65-.66,18.26,18.26,0,0,0,1.27,3.52,1.36,1.36,0,0,1-.64,1.82A1.38,1.38,0,0,1,452.37,154.8Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 486.67,
    cy: 111.98,
    rx: 7.51,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 486.33,
    cy: 109.92,
    rx: 7.4,
    ry: 9.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 483.69,
    cy: 106.51,
    rx: 2.73,
    ry: 2.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 525.69,
    cy: 111.98,
    rx: 7.51,
    ry: 9.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 525.36,
    cy: 109.92,
    rx: 7.4,
    ry: 9.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 522.71,
    cy: 106.51,
    rx: 2.73,
    ry: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.75,189.86A60,60,0,0,1,454.3,160.5a1.37,1.37,0,1,1,2.35-1.39,57.25,57.25,0,0,0,49.1,28h.07a57.11,57.11,0,0,0,57-57.11V77.74a57.23,57.23,0,0,0-16.7-40.33L546,37.3c-.58-.58-1.13-1.13-1.74-1.66-9.94-9-24-14.13-38.52-14.15h-.09c-14.75,0-28.36,5-38.33,14.13a57,57,0,0,0-18.59,42.12V130a58.27,58.27,0,0,0,.92,10.3,1.37,1.37,0,0,1-2.69.48A60.86,60.86,0,0,1,446,130V77.74A59.79,59.79,0,0,1,465.46,33.6c21.71-19.84,58.61-19.85,80.59,0,.66.57,1.27,1.18,1.86,1.77l.1.11a60,60,0,0,1,17.51,42.26V130a59.84,59.84,0,0,1-59.7,59.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.3,213.89a14.28,14.28,0,0,1-9.67-3.79A15.06,15.06,0,0,1,490.72,199V188.42a1.36,1.36,0,1,1,2.72,0V199a12.35,12.35,0,0,0,4,9.11,11.58,11.58,0,0,0,9,3l.82-.1a12.11,12.11,0,0,0,10.11-12V188.4a1.37,1.37,0,1,1,2.73,0V199a14.84,14.84,0,0,1-12.43,14.68c-.33.05-.65.09-1,.12A12.75,12.75,0,0,1,505.3,213.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 456.56,
    y: 88.86,
    width: 4.25,
    height: 22.93,
    rx: 2.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M508.12,130.22a1.37,1.37,0,0,1-1.27-.88,37,37,0,0,1-2.33-10.85V102.54a1.36,1.36,0,0,1,2.72,0v15.83a34.27,34.27,0,0,0,2.16,10,1.36,1.36,0,0,1-.79,1.76A1.41,1.41,0,0,1,508.12,130.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M531.07,17.71H502.38A39.35,39.35,0,0,0,471.06,2.16H435.38c0,28.52,22.88,52.88,51.1,52.88h80.3C566.78,35.11,550.79,17.71,531.07,17.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M550.67,23.51c9.25,6.54,15.3,18.55,15.3,30.74H484.8A51.54,51.54,0,0,1,444.2,34.5a51.41,51.41,0,0,0,31.9,11h65.65c10.45,0,16.37-13.63,9.45-21.46l-.53-.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 453.54,
    y: -5.07,
    width: 4.25,
    height: 22.93,
    rx: 2.12,
    transform: "translate(462.07 -449.27) rotate(90)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 337.53,
    cy: 339.19,
    rx: 0.96,
    ry: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 339.35,
    cy: 336.6,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 339.01,
    cy: 334.92,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 340.89,
    cy: 334.74,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 340.19,
    cy: 338.89,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 338.49,
    cy: 338.89,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 337.05,
    cy: 340.91,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 339.35,
    cy: 340.43,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 340.67,
    cy: 336.81,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 338.27,
    cy: 341.39,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 339.69,
    cy: 337.68,
    r: 0.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 162.43,
    cy: 364.29,
    rx: 8.96,
    ry: 3.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 179.44,
    cy: 364.45,
    r: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 178.34,
    cy: 372.11,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 171.18,
    cy: 369.18,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 162.43,
    cy: 372.11,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 161.69,
    cy: 367.73,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 146.4,
    cy: 363.99,
    r: 2.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 153.47,
    cy: 373.03,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 145.37,
    cy: 368.06,
    r: 2.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 555.88,
    cy: 364.98,
    rx: 8.96,
    ry: 3.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 572.89,
    cy: 365.14,
    r: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 571.79,
    cy: 372.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 564.63,
    cy: 369.87,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 561.82,
    cy: 373.87,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 555.88,
    cy: 372.8,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 555.14,
    cy: 368.42,
    r: 1.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 539.86,
    cy: 364.68,
    r: 2.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 546.92,
    cy: 373.72,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 538.82,
    cy: 368.74,
    r: 2.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 579.86,
    cy: 250.5,
    rx: 1.69,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 579.94,
    cy: 241.19,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.13,
    cy: 241.79,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 582.53,
    cy: 245.71,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.72,
    cy: 247.25,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.13,
    cy: 250.5,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 581.74,
    cy: 250.91,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 579.69,
    cy: 259.27,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.64,
    cy: 255.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 581.92,
    cy: 259.84,
    r: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 444.36,
    cy: 22.97,
    rx: 1.23,
    ry: 3.58,
    transform: "translate(43.04 215.13) rotate(-28.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 441.16,
    cy: 16.96,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 444.06,
    cy: 15.89,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 444.4,
    cy: 18.96,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 446.34,
    cy: 19.18,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 447.1,
    cy: 21.47,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 445.71,
    cy: 22.57,
    r: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M446.82,27.74a1,1,0,0,1,1.41.41c.28.51.09,2.38-.42,2.66a1,1,0,0,1-1.41-.42C446.13,29.89,446.31,28,446.82,27.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 449.14,
    cy: 24.44,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M448.41,27.28a1.09,1.09,0,0,1,1.49.44c.29.53.1,2.44-.44,2.73s-1.2-1.15-1.48-1.69A1.08,1.08,0,0,1,448.41,27.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 580.23,
    cy: 306.8,
    rx: 1.69,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 580.32,
    cy: 297.49,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.51,
    cy: 298.09,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 582.91,
    cy: 302.01,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 585.1,
    cy: 303.55,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.51,
    cy: 306.8,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 582.12,
    cy: 307.21,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 580.07,
    cy: 315.57,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 585.01,
    cy: 311.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 582.29,
    cy: 316.14,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616,320.4a.62.62,0,0,1-.62-.62V274.65A.62.62,0,0,1,616,274a.62.62,0,0,1,.62.62v45.13A.62.62,0,0,1,616,320.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M612.49,319.16a.62.62,0,0,1-.62-.62V275.89a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v42.65A.62.62,0,0,1,612.49,319.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.89,319.16a.62.62,0,0,1-.62-.62V275.89a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v42.65A.62.62,0,0,1,608.89,319.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M605.3,316.67a.62.62,0,0,1-.63-.62V279a.63.63,0,0,1,1.25,0v37.05A.62.62,0,0,1,605.3,316.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M601.7,315.43a.62.62,0,0,1-.62-.62V280.86a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v33.95A.62.62,0,0,1,601.7,315.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M598.1,312.32a.61.61,0,0,1-.62-.62V284a.61.61,0,0,1,.62-.62.62.62,0,0,1,.62.62V311.7A.62.62,0,0,1,598.1,312.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.66,319.78a.62.62,0,0,1-.62-.62V276.51a.63.63,0,0,1,1.25,0v42.65A.63.63,0,0,1,619.66,319.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M623.26,319.78a.62.62,0,0,1-.62-.62V276.51a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v42.65A.62.62,0,0,1,623.26,319.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M626.86,317.29a.62.62,0,0,1-.62-.62V279.62a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v37.05A.61.61,0,0,1,626.86,317.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.46,316.05a.62.62,0,0,1-.62-.62V281.48a.62.62,0,0,1,1.24,0v33.95A.62.62,0,0,1,630.46,316.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M634.06,311.7a.62.62,0,0,1-.62-.62V284.59a.62.62,0,1,1,1.24,0v26.49A.62.62,0,0,1,634.06,311.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615,320.4a.62.62,0,0,1-.62-.62V274.65a.62.62,0,1,1,1.24,0v45.13A.62.62,0,0,1,615,320.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M611.44,319.16a.62.62,0,0,1-.62-.62V275.89a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v42.65A.62.62,0,0,1,611.44,319.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M607.84,319.16a.62.62,0,0,1-.62-.62V275.89a.62.62,0,0,1,1.24,0v42.65A.62.62,0,0,1,607.84,319.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M604.24,316.67a.62.62,0,0,1-.62-.62V279a.62.62,0,0,1,1.24,0v37.05A.62.62,0,0,1,604.24,316.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M600.64,315.43a.62.62,0,0,1-.62-.62V280.86a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v33.95A.62.62,0,0,1,600.64,315.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M597,310.46a.62.62,0,0,1-.62-.62V285.21a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v24.63A.62.62,0,0,1,597,310.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M618.61,319.78a.62.62,0,0,1-.62-.62V276.51a.62.62,0,0,1,1.24,0v42.65A.62.62,0,0,1,618.61,319.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M622.21,319.78a.62.62,0,0,1-.62-.62V276.51a.62.62,0,0,1,1.24,0v42.65A.62.62,0,0,1,622.21,319.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M625.81,317.29a.61.61,0,0,1-.62-.62V279.62a.62.62,0,0,1,.62-.62.62.62,0,0,1,.62.62v37.05A.62.62,0,0,1,625.81,317.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M629.41,316.05a.63.63,0,0,1-.63-.62V281.48a.63.63,0,0,1,1.25,0v33.95A.62.62,0,0,1,629.41,316.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M633,313a.63.63,0,0,1-.62-.63V284.59a.63.63,0,0,1,1.25,0v27.73A.63.63,0,0,1,633,313Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.3,337.92H261.69a21.89,21.89,0,0,1-21.87-21.87,1.24,1.24,0,0,1,2.48,0,19.41,19.41,0,0,0,19.39,19.39H332.3a1.24,1.24,0,0,1,0,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M487.69,9.36a2.27,2.27,0,0,1-.72-.12l-6.62-2.32a31.93,31.93,0,0,0-10.57-1.79H440.87a2.18,2.18,0,1,1,0-4.35h28.91a36.12,36.12,0,0,1,12,2l6.61,2.31a2.18,2.18,0,0,1-.71,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M447.38,35.83a2.19,2.19,0,0,1-1.63-.73c-7.95-9-9.87-21.16-9.95-21.67a2.18,2.18,0,1,1,4.3-.66h0c0,.11,1.82,11.42,8.91,19.45a2.17,2.17,0,0,1-1.63,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M523.49,18.28h-6.17a1.37,1.37,0,0,1,0-2.73h6.17a1.37,1.37,0,1,1,0,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M566.78,55.61H485.61a51.89,51.89,0,0,1-37.49-16.16A54.5,54.5,0,0,1,432.61,1.36,1.36,1.36,0,0,1,434,0H470a41.13,41.13,0,0,1,32.32,15.55h9a1.37,1.37,0,0,1,0,2.73h-9.69a1.32,1.32,0,0,1-1.07-.53A38.4,38.4,0,0,0,470,2.73H435.35a51.86,51.86,0,0,0,14.72,34.82,49.19,49.19,0,0,0,35.54,15.33h79.78c-.72-18.89-16.32-34.6-34.7-34.6h-1.44a1.37,1.37,0,1,1,0-2.73h1.44c20.3,0,37.45,17.72,37.45,38.7A1.36,1.36,0,0,1,566.78,55.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M217,257.27h88.39a0,0,0,0,1,0,0v24.27a0,0,0,0,1,0,0H227.6A10.63,10.63,0,0,1,217,270.91V257.27A0,0,0,0,1,217,257.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.97,
    y: 180.49,
    width: 139.42,
    height: 92.63,
    rx: 7.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M356.39,253.49v9.11a9.7,9.7,0,0,1-9.69,9.7h-120a9.7,9.7,0,0,1-9.69-9.7v-9.11a9.69,9.69,0,0,0,9.69,9.69h120A9.69,9.69,0,0,0,356.39,253.49Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 216.97,
    y1: 195.71,
    x2: 350.96,
    y2: 195.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.89,274.35H224.47a8.75,8.75,0,0,1-8.74-8.73V188a8.75,8.75,0,0,1,8.74-8.73H348.89a8.75,8.75,0,0,1,8.74,8.73v77.64A8.75,8.75,0,0,1,348.89,274.35ZM224.47,181.73a6.26,6.26,0,0,0-6.26,6.25v77.64a6.27,6.27,0,0,0,6.26,6.26H348.89a6.27,6.27,0,0,0,6.26-6.26V188a6.26,6.26,0,0,0-6.26-6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.75,196.64H217a.93.93,0,1,1,0-1.86H344.75a.93.93,0,1,1,0,1.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 228.01,
    cy: 188.79,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 236.44,
    cy: 188.72,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 244.86,
    cy: 188.64,
    r: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.65,191.49h-.31a2.82,2.82,0,0,1-2.48-3.1,2.73,2.73,0,0,1,1-1.88,2.8,2.8,0,1,1,1.75,5Zm0-4.56a1.77,1.77,0,0,0-1.75,1.56,1.76,1.76,0,1,0,1.95-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.08,191.42h-.32a2.81,2.81,0,0,1,.63-5.58,2.8,2.8,0,0,1,2.47,3.1A2.81,2.81,0,0,1,236.08,191.42Zm0-4.56a1.76,1.76,0,1,0,1.75,1.95,1.77,1.77,0,0,0-.37-1.29,1.74,1.74,0,0,0-1.18-.65h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.5,191.35a1.62,1.62,0,0,1-.31,0,2.76,2.76,0,0,1-1.88-1,2.81,2.81,0,0,1-.6-2.07,2.77,2.77,0,0,1,1-1.88,2.82,2.82,0,0,1,2.06-.59,2.82,2.82,0,0,1,2.48,3.1,2.86,2.86,0,0,1-1,1.88A2.78,2.78,0,0,1,244.5,191.35Zm0-4.56a1.75,1.75,0,0,0-1.74,1.56,1.77,1.77,0,0,0,1.55,1.94,1.75,1.75,0,0,0,1.29-.37,1.76,1.76,0,0,0-.9-3.12Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 264.05,
    y1: 229.89,
    x2: 264.06,
    y2: 223.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,217.59a.71.71,0,0,1,0-1.42l54-.48h0a.71.71,0,0,1,.71.7.72.72,0,0,1-.71.72l-54,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,222.38a.72.72,0,0,1-.71-.7.7.7,0,0,1,.7-.71l38.51-.48h0a.71.71,0,1,1,0,1.41l-38.51.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,227.18a.71.71,0,0,1,0-1.42l21.11-.48a.73.73,0,0,1,.72.7.7.7,0,0,1-.69.72l-21.11.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,235.35a.71.71,0,0,1,0-1.42l54-.48h0a.71.71,0,0,1,.71.7.72.72,0,0,1-.71.72l-54,.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,240.14a.72.72,0,0,1-.71-.7.7.7,0,0,1,.7-.71l38.51-.48h0a.71.71,0,1,1,0,1.41l-38.51.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.69,244.94a.71.71,0,0,1,0-1.42l21.11-.48a.73.73,0,0,1,.72.7.7.7,0,0,1-.69.72l-21.11.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 257.48,
    y: 212.17,
    width: 8.09,
    height: 1.55,
    rx: 0.77,
    transform: "translate(17.78 446.02) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 260.13,
    y: 216.69,
    width: 8.09,
    height: 1.55,
    rx: 0.77,
    transform: "translate(15.61 452.61) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 255.62,
    y: 241.14,
    width: 4.64,
    height: 0.89,
    rx: 0.44,
    transform: "translate(-13.78 467.56) rotate(-82.87)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 267.43,
    y1: 233.8,
    x2: 267.44,
    y2: 227.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M267.46,221.23l0-8.57a4.25,4.25,0,0,0-4.23-4.27h0l-29.82-.06a4.26,4.26,0,0,0-4.28,4.23v0l-.07,36.07a4.26,4.26,0,0,0,4.23,4.28h0l29.82.06a4.26,4.26,0,0,0,4.28-4.23v-7.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M230.14,229.91a.94.94,0,0,1-.95-.92l-.11-16.73c-.07-4.25,3.15-4.42,7.4-4.5a.94.94,0,1,1,.27,1.87h-.23a5.85,5.85,0,0,0-5.72,6l.26,13.36A1,1,0,0,1,230.14,229.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 231.23,
    cy: 226.12,
    rx: 1.13,
    ry: 1.42,
    transform: "translate(-4.31 4.49) rotate(-1.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 232.51,
    cy: 224.11,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 232.1,
    cy: 228.38,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 233.33,
    cy: 226.37,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 231,
    cy: 219.97,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 231.44,
    cy: 222.62,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 232.51,
    cy: 217.27,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 232.33,
    cy: 214.58,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 232.76,
    cy: 211.34,
    r: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.79,253.07h0L232.94,253a5,5,0,0,1-3.57-1.49,5,5,0,0,1-1.44-3.55l.07-36.08a5,5,0,0,1,5-5h0l29.83.06a5,5,0,0,1,5,5v8.57h0l-.06,27.54a5,5,0,0,1-1.49,3.56A4.94,4.94,0,0,1,262.79,253.07ZM233,208.39a3.5,3.5,0,0,0-3.49,3.47L229.45,248a3.47,3.47,0,0,0,3.47,3.51l29.85.06a3.53,3.53,0,0,0,2.48-1,3.44,3.44,0,0,0,1-2.46l.08-36.13a3.51,3.51,0,0,0-3.49-3.5L233,208.39Zm34.09,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M262.75,236h0a1.19,1.19,0,0,1,1.2,1.19l.05,9.2a1.2,1.2,0,0,1-1.19,1.2h0a1.19,1.19,0,0,1-1.2-1.19l-.05-9.2A1.19,1.19,0,0,1,262.75,236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.74,226.78h0a.92.92,0,0,1,.92.92l0,7.07a.92.92,0,0,1-.91.92h0a.92.92,0,0,1-.93-.91l0-7.07A.93.93,0,0,1,231.74,226.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M71.77,275.23v8.18l15.11,5.29s3.39,13,16.45,13,15.27-17.42,15.27-17.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.12,
    y: 233.44,
    width: 9.07,
    height: 72.78,
    transform: "translate(-215.16 240.76) rotate(-71.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.73,286.79a1,1,0,0,1-.35-.06l-69-23.1a1.07,1.07,0,0,1-.63-.55,1.09,1.09,0,0,1-.06-.85l2.88-8.6a1.09,1.09,0,0,1,1.39-.69L96,276a1.1,1.1,0,0,1,.63.55,1.11,1.11,0,0,1,.06.84L93.77,286A1.09,1.09,0,0,1,92.73,286.79Zm-67.62-24.9L92,284.29l2.18-6.51-66.92-22.4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 15.54,
    cy: 255.17,
    r: 14.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.57,270.7a15.52,15.52,0,1,1,7.49-1.93A15.53,15.53,0,0,1,15.57,270.7Zm-.05-28.87a13.35,13.35,0,0,0-12.79,9.65A13.33,13.33,0,0,0,22,266.84a13.33,13.33,0,0,0-2.76-24.48A13.47,13.47,0,0,0,15.52,241.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 15.54,
    cy: 255.17,
    r: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.56,264.25a9.09,9.09,0,1,1,4.37-1.13A9,9,0,0,1,15.56,264.25Zm0-16a6.81,6.81,0,0,0-3.31.86,6.9,6.9,0,0,0-2.7,9.35,6.88,6.88,0,1,0,7.93-9.94A7,7,0,0,0,15.53,248.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 123.54,
    cy: 210.16,
    r: 12.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 108.02,
    y: 204.21,
    width: 9.07,
    height: 72.78,
    transform: "translate(165.2 500.96) rotate(-166.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M122.67,217.83l-1.1,4.52a14.42,14.42,0,0,1-8.65-2.82l.93-3.85A14.45,14.45,0,0,0,122.67,217.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.38,278.14a.82.82,0,0,1-.26,0L99.31,276a1.09,1.09,0,0,1-.81-1.33l17.16-70.73a1.08,1.08,0,0,1,.5-.68,1.1,1.1,0,0,1,.83-.13l8.82,2.14a1.1,1.1,0,0,1,.81,1.33l-17.17,70.72a1.11,1.11,0,0,1-1.07.85Zm-7.48-4.06,6.67,1.62,16.65-68.58-6.68-1.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 121.67,
    cy: 203.06,
    r: 14.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.69,218.59a15.52,15.52,0,1,1,7.49-1.93A15.53,15.53,0,0,1,121.69,218.59Zm0-28.86A13.32,13.32,0,0,0,110,209.51a13.33,13.33,0,1,0,11.64-19.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 121.67,
    cy: 203.06,
    r: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.68,212.14a9.08,9.08,0,1,1,7.93-13.47h0a9.07,9.07,0,0,1-7.93,13.47Zm0-16a6.88,6.88,0,1,0,6,3.55h0A6.91,6.91,0,0,0,121.65,196.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 104.16,
    cy: 283.21,
    r: 14.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.19,298.74a15.53,15.53,0,1,1,13.57-23.05h0a15.53,15.53,0,0,1-13.57,23.05Zm0-28.87a13.21,13.21,0,0,0-6.43,1.67,13.33,13.33,0,1,0,18.12,5.22,13.4,13.4,0,0,0-11.69-6.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 104.16,
    cy: 283.21,
    r: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.17,292.29a9.08,9.08,0,1,1,7.94-13.47h0a9.08,9.08,0,0,1-7.94,13.47Zm0-16a6.88,6.88,0,1,0,6,3.55h0a6.83,6.83,0,0,0-4.12-3.28A6.94,6.94,0,0,0,104.15,276.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.55,311.3a1.17,1.17,0,0,1-1.17-1.17V279.48a1.17,1.17,0,0,1,2.34,0v30.65A1.17,1.17,0,0,1,520.55,311.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.55,273.51a1.17,1.17,0,0,1-1.17-1.17v-5.8a1.17,1.17,0,0,1,2.34,0v5.8A1.17,1.17,0,0,1,520.55,273.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M538.86,152.62c0,19.29-14.61,34.93-32.68,35h-1.33c-17.68-.07-32.1-15.12-32.65-34l-.31-14.83c1.42-5.57,5.44-6.1,10.47-7.16h46c5,1.05,9.05.09,10.48,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M482,139.28h47.82v10.57a23.91,23.91,0,0,1-23.91,23.91h0A23.91,23.91,0,0,1,482,149.85V139.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M510.83,173.21a23.91,23.91,0,0,1-28.34-18.45,23.3,23.3,0,0,1-.52-4.92V139.28h9.93v10.56A23.9,23.9,0,0,0,510.83,173.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 490.11,
    y: 139.28,
    width: 39.66,
    height: 14.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 490.11,
    y: 139.28,
    width: 39.66,
    height: 6.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M527.58,155.37v2.78c0,8.41-6.81,14-15.22,14-2.65,0-5.15,1.84-7.32.63l-.11-.92a16.81,16.81,0,0,1-.28-2.93,15.48,15.48,0,0,1,22.84-13.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M515.17,172.05a15.06,15.06,0,0,1-2.76.24c-2.66,0-5.15,1.85-7.32.63L505,172a16.06,16.06,0,0,1-.28-2.93,15.65,15.65,0,0,1,.27-2.9C506.9,170.34,510.64,171,515.17,172.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505,173.25a.8.8,0,0,1-.79-.66,16.28,16.28,0,0,1,23.75-17.36.81.81,0,0,1-.77,1.42,14.67,14.67,0,0,0-21.4,15.64.79.79,0,0,1-.64.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M508.67,161.49a.34.34,0,0,1-.23-.08.4.4,0,0,1-.09-.56A15,15,0,0,1,519,154.91a.4.4,0,1,1,.07.79A14.19,14.19,0,0,0,509,161.33.36.36,0,0,1,508.67,161.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 510.25,
    cy: 160.57,
    rx: 1.52,
    ry: 0.97,
    transform: "translate(86.51 487.04) rotate(-55.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 512.9,
    cy: 159.8,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 511.91,
    cy: 162.43,
    r: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.5,155.06H490.11a1.27,1.27,0,0,1-1.27-1.27V139.9a1.27,1.27,0,0,1,2.53,0v12.62H528.5a1.27,1.27,0,0,1,0,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M506.93,174.94h-2.12a24.08,24.08,0,0,1-24.05-24v-9.42a3.41,3.41,0,0,1,3.41-3.41h43.39a3.41,3.41,0,0,1,3.41,3.4v9.41a24.05,24.05,0,0,1-24.05,24.06Zm-22.76-34.45a1,1,0,0,0-.7.29,1,1,0,0,0-.29.7v9.42a21.64,21.64,0,0,0,21.62,21.61h2.12a21.59,21.59,0,0,0,21.62-21.63v-9.4a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M545.93,133.71h-2.72a2,2,0,0,1-2-1.63L533,89.3a2,2,0,0,1,2-2.39h2.72a2,2,0,0,1,2,1.63l8.26,42.78A2,2,0,0,1,545.93,133.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M535,132.44h0a2,2,0,0,1-2-1.63L524.73,88a2,2,0,0,1,2-2.39h0a2,2,0,0,1,2,1.63l8.26,42.78A2,2,0,0,1,535,132.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M535.58,82.54a27.59,27.59,0,1,0,27.58,27.58A27.58,27.58,0,0,0,535.58,82.54Zm0,47.7a20.13,20.13,0,1,1,20.12-20.12A20.12,20.12,0,0,1,535.58,130.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M563.16,110.12c0,.53,0,1.07,0,1.6a27.58,27.58,0,0,0-55.07,0c0-.53-.06-1.07-.06-1.6a27.59,27.59,0,1,1,55.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535.81,138.56a28.84,28.84,0,1,1,28.84-28.84A28.87,28.87,0,0,1,535.81,138.56Zm0-55.18a26.34,26.34,0,1,0,26.33,26.34A26.37,26.37,0,0,0,535.81,83.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M535.81,131.09a21.38,21.38,0,1,1,21.37-21.37A21.4,21.4,0,0,1,535.81,131.09Zm0-40.24a18.87,18.87,0,1,0,18.87,18.87A18.88,18.88,0,0,0,535.81,90.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M485.85,133.71h-2.72a2,2,0,0,1-2-1.63L472.9,89.3a2,2,0,0,1,2-2.39h2.71a2,2,0,0,1,2,1.63l8.25,42.78A2,2,0,0,1,485.85,133.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M474.88,132.44h0a2,2,0,0,1-2-1.63L464.65,88a2,2,0,0,1,2-2.39h0a2,2,0,0,1,2,1.63l8.25,42.78A2,2,0,0,1,474.88,132.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M475.49,82.54a27.59,27.59,0,1,0,27.59,27.58A27.58,27.58,0,0,0,475.49,82.54Zm0,47.7a20.13,20.13,0,1,1,20.12-20.12A20.12,20.12,0,0,1,475.49,130.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M503.08,110.12c0,.53,0,1.07-.06,1.6a27.58,27.58,0,0,0-55.06,0c0-.53-.06-1.07-.06-1.6a27.59,27.59,0,1,1,55.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.72,138.56a28.84,28.84,0,1,1,28.84-28.84A28.88,28.88,0,0,1,475.72,138.56Zm0-55.18a26.34,26.34,0,1,0,26.34,26.34A26.37,26.37,0,0,0,475.72,83.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.72,131.09a21.38,21.38,0,1,1,21.38-21.37A21.4,21.4,0,0,1,475.72,131.09Zm0-40.24a18.87,18.87,0,1,0,18.87,18.87A18.89,18.89,0,0,0,475.72,90.85Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 481.22,
    cy: 176.24,
    rx: 2.89,
    ry: 1.66,
    transform: "translate(162.51 577.56) rotate(-71.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 486.45,
    cy: 177.86,
    r: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M483.61,178.8a.72.72,0,1,1,0,1.44.72.72,0,0,1,0-1.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 484.56,
    cy: 172.87,
    r: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.44,180.22a1.16,1.16,0,0,1-.87-.39L538,174.78a1.17,1.17,0,0,1,1.74-1.56l4.53,5.05a1.17,1.17,0,0,1-.09,1.65A1.19,1.19,0,0,1,543.44,180.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M556,166.12a1.16,1.16,0,0,1-.87-.39l-4.53-5a1.17,1.17,0,0,1,1.74-1.56l4.53,5a1.17,1.17,0,0,1-.09,1.65A1.16,1.16,0,0,1,556,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.26,189.2a1.17,1.17,0,0,1-1.1-.78L521.9,182a1.17,1.17,0,1,1,2.2-.77l2.26,6.39a1.16,1.16,0,0,1-.71,1.49A1.07,1.07,0,0,1,525.26,189.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M533.49,187.45a1.17,1.17,0,0,1-1.1-.78l-1.46-4.14a1.17,1.17,0,0,1,2.21-.77l1.46,4.13a1.17,1.17,0,0,1-.72,1.49A1.07,1.07,0,0,1,533.49,187.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M534.13,169.55a1.15,1.15,0,0,1-1-.62l-1.66-3.08a1.17,1.17,0,1,1,2-1.11l1.66,3.09a1.16,1.16,0,0,1-.47,1.58A1.25,1.25,0,0,1,534.13,169.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M545.37,166.94a1.16,1.16,0,0,1-1-.48l-2.08-2.89a1.17,1.17,0,0,1,1.89-1.37l2.09,2.9a1.17,1.17,0,0,1-.27,1.62A1.15,1.15,0,0,1,545.37,166.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M467.31,180.22a1.19,1.19,0,0,1-.78-.3,1.17,1.17,0,0,1-.09-1.65l4.53-5.05a1.17,1.17,0,1,1,1.74,1.56l-4.53,5.05A1.16,1.16,0,0,1,467.31,180.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.75,166.12a1.16,1.16,0,0,1-.78-.3,1.17,1.17,0,0,1-.09-1.65l4.53-5a1.17,1.17,0,1,1,1.74,1.56l-4.53,5A1.16,1.16,0,0,1,454.75,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.49,189.2a1.07,1.07,0,0,1-.39-.07,1.16,1.16,0,0,1-.71-1.49l2.26-6.39a1.17,1.17,0,1,1,2.2.77l-2.26,6.4A1.17,1.17,0,0,1,485.49,189.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M477.26,187.45a1,1,0,0,1-.39-.07,1.17,1.17,0,0,1-.72-1.49l1.46-4.13a1.17,1.17,0,0,1,2.21.77l-1.46,4.14A1.17,1.17,0,0,1,477.26,187.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M476.62,169.55a1.25,1.25,0,0,1-.55-.14,1.16,1.16,0,0,1-.47-1.58l1.66-3.09a1.17,1.17,0,1,1,2.05,1.11l-1.66,3.08A1.15,1.15,0,0,1,476.62,169.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M465.38,166.94a1.15,1.15,0,0,1-.68-.22,1.17,1.17,0,0,1-.27-1.62l2.08-2.9a1.17,1.17,0,0,1,1.9,1.37l-2.08,2.89A1.16,1.16,0,0,1,465.38,166.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.22,156.66a1.17,1.17,0,0,1-1-1.72l1.66-3.09a1.17,1.17,0,0,1,2.06,1.11l-1.66,3.09A1.16,1.16,0,0,1,473.22,156.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M462,154.06a1.2,1.2,0,0,1-.68-.22,1.16,1.16,0,0,1-.27-1.63l2.08-2.89a1.16,1.16,0,0,1,1.63-.27,1.18,1.18,0,0,1,.27,1.63l-2.08,2.89A1.17,1.17,0,0,1,462,154.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.11,155.08a1.16,1.16,0,0,1-1-.61l-1.66-3.09a1.17,1.17,0,1,1,2.05-1.11l1.67,3.09a1.17,1.17,0,0,1-1,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M553.35,152.48a1.17,1.17,0,0,1-1-.49l-2.08-2.89a1.17,1.17,0,1,1,1.9-1.36l2.08,2.89a1.17,1.17,0,0,1-.27,1.63A1.13,1.13,0,0,1,553.35,152.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 638.68,
    cy: 220.25,
    r: 8.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M647.15,220.25a8.47,8.47,0,0,1-16.94,0c0-4.68,3.79,1.05,8.47,1.05S647.15,215.57,647.15,220.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M638.68,229.93a9.69,9.69,0,1,1,9.69-9.68A9.69,9.69,0,0,1,638.68,229.93Zm0-16.93a7.25,7.25,0,1,0,7.25,7.25A7.26,7.26,0,0,0,638.68,213Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 598.1,
    cy: 220.25,
    r: 8.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M606.57,220.25a8.47,8.47,0,0,1-16.94,0c0-4.68,3.79,1.05,8.47,1.05S606.57,215.57,606.57,220.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M598.1,229.93a9.69,9.69,0,1,1,9.68-9.68A9.7,9.7,0,0,1,598.1,229.93Zm0-16.93a7.25,7.25,0,1,0,7.25,7.25A7.26,7.26,0,0,0,598.1,213Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuxCat);
export default __webpack_public_path__ + "static/media/gux_cat.4601981cc02e5d4136e5da2a961f3a46.svg";
export { ForwardRef as ReactComponent };